<template>
  <link id="bootstrap" href="/css/custom.css" rel="stylesheet">

  <NavBarNew :hiddenOption="false"/>
  <loading v-bind:loading="data_.loading" />
  <alert @onFire="eventCloseAlert" v-bind:data_alert="data_alert" />


  <header id="login">
    <div class="container-fluid" v-if="data_.step === 1" >
      <div class="row">
        <div class="col-xxl-6 col-xl-7 col-lg-8 col-md-10 mx-auto">

          <div class="card">
            <div class="card-body">
              <h1 class="display-3 mb-3 text-center">Recuperar contraseña</h1>
              <p class="fw-medium mb-2">Escribe tu NIF/CIF</p>

              <form @submit.prevent="submit" class="mb-2" autocomplete="off">

                <div class="form-floating mb-2">
                  <input @change="setUserName()" v-model="data.cif"  type="text" class="form-control" id="floatingInput" placeholder="NIF/CIF" required>
                  <label for="floatingInput">NIF/CIF</label>
                </div>

                <div class="form-floating mb-2">
                  <input v-model="data.phoneNumber" type="text" class="form-control" id="floatingInput" placeholder="Teléfono móvil" required>
                  <label for="floatingInput">Teléfono móvil</label>
                </div>


                <button class="w-100 btn btn-lg btn-primary mt-4" type="submit">Enviar</button>

              </form>

              <div class="text-center p-2 small">
                <router-link to="/login" class="text-link">Ya la recuerdo</router-link>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div v-if="data_.step === 2">
      <form-code-msg
          type="recovery"
          @onFire="getToken"
          @onFireCode="submit()"
          v-model:code_="data_login_code.code"
          :id="data_login.userId"
      />
    </div>

    <div class="container-fluid" v-if="data_.step === 3" >
      <div class="row">
        <div class="col-xxl-6 col-xl-7 col-lg-8 col-md-10 mx-auto">

          <div class="card">
            <div class="card-body">
              <h1 class="display-3 mb-3 text-center">Actualizar Contraseña</h1>
              <p class="fw-medium mb-2">Introduce tu nueva contraseña</p>

              <form @submit.prevent="updatePassword" class="mb-2" autocomplete="off">

                <div class="form-floating mb-2">
                  <input @change="changePass()" v-model="data_login.newPassword" :type="form_.showPass ? 'text' : 'password'" class="form-control" id="floatingPassword" placeholder="Contraseña" required>
                  <label for="floatingPassword">Contraseña</label>
                  <div  @click="showPass()" class="view-pass">
                    <i class="bi bi-eye" v-if="!form_.showPass"></i>
                    <i class="bi bi-eye-slash" v-if="form_.showPass"></i>
                  </div>
                </div>

                <div class="form-floating mb-2">
                  <input @change="changePass()" v-model="data_login.repeatNewPassword" :type="form_.showPass ? 'text' : 'password'" class="form-control" id="floatingPassword" placeholder="Contraseña" required>
                  <label for="floatingPassword">Repetir contraseña</label>
                  <div  @click="showPass()" class="view-pass">
                    <i class="bi bi-eye" v-if="!form_.showPass"></i>
                    <i class="bi bi-eye-slash" v-if="form_.showPass"></i>
                  </div>
                </div>




                <button class="w-100 btn btn-lg btn-primary mt-4" type="submit">Enviar</button>

              </form>

              <div class="text-center p-2 small">
                <router-link   to="/login"  class="text-link">Ya la recuerdo</router-link>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

  </header>
</template>

<script lang="ts">
import { reactive } from "vue";
import axios from "axios";
import { goRoute, state } from "@/api/global";
import Loading from "../../components/Commons/Loading.vue";
import Alert from "../../components/Commons/Alert.vue";
import { messageVaidate } from "@/api/utilities";
import Back from "@/components/Commons/Back.vue";
import FormCodeMsg from "@/components/Client/FormCodeMsg.vue";
import NavBarNew from "@/components/Commons/navBarNew.vue";

export default {
  name: "Recovery",
  components: { Loading, Alert, Back, FormCodeMsg, NavBarNew },
  setup() {
    const { colors } = state.configTenant.template;

    const data_ = reactive({
      loading: false,
      step: 1,
    });

    const data = reactive({
      cif: "",
      phoneNumber: "",
    });

    const data_login_code = reactive({
      userId: "",
      code: "",
    });

    const data_login = reactive({
      userId: "",
      authCode: "",
      newPassword: "",
      repeatNewPassword: "",
    });

    const data_alert = reactive({
      title: "",
      msg: "",
      description: "",
      type: "",
      open: false,
    });

    const form_ = reactive({
      errorPass: false,
      showPass: false,
    });

    const changePass = () => {
      if (
        data_login.newPassword !== "" &&
        data_login.repeatNewPassword !== "" &&
        data_login.newPassword !== undefined &&
        data_login.repeatNewPassword !== undefined &&
        data_login.newPassword !== data_login.repeatNewPassword
      ) {
        form_.errorPass = true;
      } else {
        form_.errorPass = false;
      }
    };

    const showPass = () => {
      form_.showPass = !form_.showPass;
    };

    const eventCloseAlert = () => {
      data_alert.open = false;
    };

    const setStep = (step: number) => {
      data_.step = step;
    };

    const submit = async () => {
      data_.loading = true;
      const url = process.env.VUE_APP_BASE_URL + "/User/rememberpassword";

      let response = null;
      try {
        response = await axios.post(url, data);
      } catch (e: any) {
        response = e.response || e.request;
      }

      if (response.status == 200) {
        data_login.userId = response.data.userId;
        data_login_code.code = response.data.authCode.code;
        setStep(2);
        data_.loading = false;
      } else {
        const msg = response.data.title;
        const er = messageVaidate(msg);
        data_.loading = false;
        data_alert.open = true;
        data_alert.type = "danger";
        data_alert.title = "¡Error!";
        data_alert.msg =
          "Hubo un problema al tratar de obtener el usuario. Verifique el CIF o el teléfono";
        data_alert.description = response.data
          ? er.length > 0
            ? er[0].traduction_es
            : msg
          : "No se pudo establecer conexión";

        window.scrollTo(0, 0);
        await setTimeout(function () {
          data_alert.open = false;
        }, 3000);
      }
    };

    const getToken = async (code: string) => {
      data_login.authCode = code;
      setStep(3);
    };

    const updatePassword = async () => {
      data_.loading = true;
      const url = process.env.VUE_APP_BASE_URL + "/User/newpassword";
      let response = null;
      try {
        response = await axios.put(url, data_login);
      } catch (e: any) {
        response = e.response || e.request;
      }

      if (response.status == 200) {
        //createSession(JSON.stringify(response.data));
        data_.loading = false;
        data_alert.open = true;
        data_alert.type = "success";
        data_alert.title = "OK!";
        data_alert.msg = "Contraseña actualizada con éxito";
        data_alert.description = "";

        window.scrollTo(0, 0);
        await setTimeout(function () {
          goRoute("/login");
        }, 3000);
      } else {
        const msg = response.data.title;
        const er = messageVaidate(msg, msg);
        data_.loading = false;
        data_alert.open = true;
        data_alert.type = "danger";
        data_alert.title = "¡Error!";
        data_alert.msg = response
          ? "Hubo un problema al tratar de cambiar la contraseña."
          : "No se pudo establecer conexión";
        data_alert.description = response.data
          ? er.length > 0
            ? er[0].traduction_es
            : msg
          : "No se pudo establecer conexión";

        window.scrollTo(0, 0);
        await setTimeout(function () {
          data_alert.open = false;
          if (msg === "USER_INVALID_OR_EXPIRED_CODE") {
            setStep(2);
          }
        }, 3000);
      }
    };

    return {
      data,
      data_login,
      data_login_code,
      data_,
      submit,
      eventCloseAlert,
      updatePassword,
      data_alert,
      colors,
      setStep,
      changePass,
      form_,
      showPass,
      getToken,
    };
  },
};
</script>
